export default __webpack_public_path__ + "static/media/Emergency_Breakdown.34c1a36a.svg";